export default __webpack_public_path__ + "static/Alexander-4a212306a4d238b0920419c711529e4ef9fe3310debeee958f11fb5b33da29b5.svg";